import React, { useState, useEffect } from "react";
import styles from "./Header.module.css";
import Icon from "../../pages/Home/common/Icon";
import automationLogo from "../../../images/Automationlogo.png";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`${styles.headerWrapper} ${scrolled ? styles.headerScrolled : ""}`}>
      {/* Top utility bar */}
      <div className={styles.topbar}>
        <div className={styles.topbarInner}>
          <div className={styles.topbarLeft}>
            <span className={styles.topbarItem}>
              <Icon.Clock /> Working hours : Mon – Sat 9:00 – 18:00
            </span>
             <a href="tel:+91-124-4477-951" className={styles.topbarItem}>
               <Icon.Phone /> Call us : +91 124 4477 951
             </a>
          </div>
          <div className={styles.topbarRight}>
             <a href="https://www.facebook.com/allianceautomationindia/" aria-label="Facebook" className={styles.iconLink}><Icon.Facebook /></a>
             <a href="https://www.linkedin.com/in/alliance-automation-2bb24053" aria-label="LinkedIn" className={styles.iconLink}><Icon.LinkedIn /></a>
             <a href="https://www.youtube.com/channel/UC-0RZR5y9seI-2qjIocyYCw?themeRefresh=1" aria-label="YouTube" className={styles.iconLink}><Icon.YouTube /></a>
            <button className={styles.iconLink} aria-label="Search" type="button">
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                <circle cx="10.5" cy="10.5" r="7" stroke="currentColor" strokeWidth="2" />
                <path d="M15.5 15.5L21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
             <a href="/contact" className={styles.topbarCta}>Leave a note</a>
          </div>
        </div>
      </div>

      {/* Red branding bar */}
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <a href="/" className={styles.logo} aria-label="Alliance Automation Home">
            <img
              src={automationLogo}
              alt="Alliance Automation"
              className={styles.logoImg}
            />
          </a>
        </div>
      </header>
    </div>
  );
}
